import { GridColumn } from '@tkww/orion-web-ds-structure';
import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import Styles from './styles.scss';

export default class BowSection extends PureComponent {
	static propTypes = {
		body: PropTypes.object,
		title: PropTypes.string.isRequired,
		titleType: PropTypes.oneOf(['h1', 'h2', 'h3']),
	};

	static defaultProps = {
		body: null,
		titleType: 'h1',
	};

	renderTitle() {
		const { title } = this.props;

		switch (this.props.titleType) {
			case 'h2':
				return <h2 className={Styles.bowSectionTitle}>{title}</h2>;
			case 'h3':
				return <h3 className={Styles.bowSectionTitle}>{title}</h3>;
			default:
				return <h1 className={Styles.bowSectionTitle}>{title}</h1>;
		}
	}

	render() {
		const { body } = this.props;
		return (
			<div>
				{this.renderTitle()}
				{body && (
					<GridColumn md="8" className={Styles.bowSectionBody}>
						{body}
					</GridColumn>
				)}
			</div>
		);
	}
}
